window.upcartOnCartUpdated = function (cart) {
  fetchCart();
}

window.upcartOnCartOpened = function (cart) {
  const country = window.localization_country;
  setTimeout(function() {
    fetchCart();
  }, 50);

  setTimeout(function() {
    const shippingFElement = document.querySelector('.styles_Footer__cartShippingTitle__');
    const targetFElement = document.querySelector('.styles_Footer__cartSubtotalTitle__');
    const shippingFHtml = `
      <div class="styles_Footer__cartShippingTitle__ styles_Footer__alignLeft__ UpcartDesignSettings__subtotalTextColor">
        <span>Shipping</span>
        <span class="upcart__shipping_label"><strong>FREE</strong></span>
      </div>`;

    if(!shippingFElement) {
      targetFElement.insertAdjacentHTML('afterend', shippingFHtml);
    }
  }, 150);
}

const currencySymbols = {
  'AUD': 'A$',
  'BRL': 'R$',
  'CAD': 'C$',
  'CHF': 'CHF',
  'CNY': '元',
  'CZK': 'Kč',
  'DKK': 'kr',
  'EUR': '€',
  'GBP': '£',
  'HKD': 'HK$',
  'HUF': 'Ft',
  'ILS': '₪',
  'INR': '₹',
  'JPY': '¥',
  'KRW': '₩',
  'MXN': '$',
  'NOK': 'kr',
  'NZD': 'NZ$',
  'PHP': '₱',
  'PLN': 'zł',
  'RON': 'lei',
  'RUB': '₽',
  'SEK': 'kr',
  'SGD': 'S$',
  'THB': '฿',
  'TRY': '₺',
  'TWD': 'NT$',
  'USD': '$',
  'ZAR': 'R',
  'BDT': 'Tk',
};

function fetchCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      processCartItems(cart.items, cart.total_price, cart.currency);
      setTimeout(function() {
        //
        handleFinalSaleLogic(cart.items);
      }, 20);
    })
    .catch(error => console.error('Error al recuperar el carrito:', error));
}

function processCartItems(items, totalPrice, currency) {
  let totalCompareAtPrice = 0;
  let totalPriceOfItems = 0;

  const promises = items.map(item => {
    const variantId = item.id;

    return fetch(`/variants/${variantId}.js`)
      .then(response => response.json())
      .then(variant => {
        const savingsElement = document.querySelector(`.upcart-product-item[id^="${variantId}"] .upcart-product-savings`);

        if (variant.compare_at_price > variant.price) {
          const savingsPerItem = variant.compare_at_price - variant.price; // Ahorro por producto
          totalCompareAtPrice += variant.compare_at_price * item.quantity; // Sumar al total comparativo
          totalPriceOfItems += variant.price * item.quantity; // Sumar al total de precios

          // Calcular el porcentaje de descuento
          const discountPercentage = Math.floor((savingsPerItem / variant.compare_at_price) * 100); // Porcentaje de descuento
          
          // Actualiza el elemento de ahorros
          if (savingsElement) {
            savingsElement.textContent = `${discountPercentage}% OFF`;
            savingsElement.style.display = 'block'; // Cambia el display a block
          }
        }
      })
      .catch(error => console.error(`Error al recuperar el variante ${variantId}:`, error));
  });

  Promise.all(promises).then(() => {
    // Calcular y mostrar el total de ahorros en el carrito
    const savings = totalCompareAtPrice - totalPriceOfItems;
    const currencySymbol = currencySymbols[currency] || currency;
    const savingsElement = document.querySelector('.styles_Footer__cartCustomSavingsTitle__');
    const shippingElement = document.querySelector('.styles_Footer__cartShippingTitle__');
    const targetElement = document.querySelector('.styles_Footer__cartSubtotalTitle__');

    if (savings > 0) {      
      const savingsHtml = `
      <div class="styles_Footer__cartCustomSavingsTitle__ styles_Footer__alignLeft__ UpcartDesignSettings__subtotalTextColor">
          <span>Savings</span>
          <span class="upcart__savings_amount">-${currencySymbol} ${(savings / 100).toFixed(2)}</span>
      </div>
      `;

      if (targetElement) {
        if(!shippingElement) {
          targetElement.insertAdjacentHTML('afterend', shippingHtml);
        }
        if (savingsElement) {
          savingsElement.innerHTML = savingsHtml;
        } else {
          targetElement.insertAdjacentHTML('beforebegin', savingsHtml);
        }
      }
    }

    // Remover el elemento de ahorros si no hay ahorros
    const element = document.querySelector('.styles_Footer__cartCustomSavingsTitle__');
    if (element && savings <= 0) {
      element.remove();
    }
  });
}

function handleFinalSaleLogic(items) {
  const country = window.localization_country;
  const specialProductId = 46417597038810; // Variant ID - NOT Product ID
  const finalSaleItems = items.filter(item => 
    item.title.toLowerCase().includes("final sale") || 
    (item.properties && item.properties['_note'] === "Final Sale")
  );

  const nonFinalSaleItems = items.filter(item => 
    !item.title.toLowerCase().includes("final sale") && 
    (!item.properties || item.properties['_note'] !== "Final Sale")
  );

  const hasSpecialProduct = items.some(item => item.id === specialProductId);
  console.log('Try');

  if(country == 'United States') {
    if (finalSaleItems.length > 0 && nonFinalSaleItems.length > 0) {
      if (hasSpecialProduct) {
        removeItemFromCart(specialProductId);
      } else {
        if (!hasSpecialProduct) {
          addItemToCart(specialProductId, true);
        }
      }
    } else if (finalSaleItems.length > 0) {
      // Si solo hay productos con "final sale"
      if (hasSpecialProduct) {
        
        // Si el producto especial está en el carrito, eliminarlo
        removeItemFromCart(specialProductId);
      }
    } else {
      // Si no hay productos con "final sale"
      if (!hasSpecialProduct) {
        if (!hasSpecialProduct) {
          // Agregar el producto especial sin nota
          addItemToCart(specialProductId, false);
        }
      }
    }
  } else {
    removeItemFromCart(specialProductId);
  }

  setTimeout(function() {
    const priceRow = document.querySelector('[id^="46417597038810"] .styles_ProductRow__price__');
    const priceFreeRow = document.querySelector('[id^="46417597038810"] .styles_ProductRow__price__ .upcart-free-label');
    if (priceRow && !priceFreeRow) {
      const freeSpan = document.createElement('span');
      freeSpan.textContent = 'Free';
      freeSpan.classList.add('upcart-free-label');
      priceRow.appendChild(freeSpan);
    }
  }, 400);
}

function addItemToCart(productId, hasFinalSaleItems) {
  const note = hasFinalSaleItems ? "No returns or exchanges on final sale items." : "";

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: productId, quantity: 1, properties: { Note: note } })
  })
  .then(response => response.json())
  .then(cart => {
    console.log('Producto agregado:', cart);
    // Actualizar el carrito u otra lógica después de agregar el producto
  })
  .catch(error => console.error('Error al agregar el producto:', error));
}

function removeItemFromCart(variantId) {
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    const itemToRemove = cart.items.find(item => item.variant_id === variantId);
    if (itemToRemove) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemToRemove.key, quantity: 0 })
      })
      .then(response => response.json())
      .then(updatedCart => {
        console.log('Producto eliminado:', updatedCart);
      })
      .catch(error => console.error('Error al eliminar el producto:', error));
    } else {
      console.warn('No se encontró el producto con variant_id:', variantId);
    }
  });
}
